import { Box, Button, Typography } from '@mui/material';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';
import Card from '@src/main/ui/components/common/Card/Card';
import Modal from '@src/main/ui/components/common/Modal/Modal';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import React, { type FC } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies

interface Props {
  dashboard: Dashboard;
  onClose: () => void;
}

const AdminAddDashboardConfirmDeleteModal: FC<Props> = ({ dashboard, onClose }) => {
  const { deleteDashboard } = useDashboardContext();

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deleteDashboard(dashboard.id);
    onClose();
  };

  return (
    <>
      <Modal open handleClose={onClose}>
        <Card width="90vw" maxWidth="650px" maxHeight="75vh">
          <form onSubmit={submit}>
            <Box
              sx={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
              }}
            >
              <Typography variant="h5">Delete dashboard</Typography>
              <Typography>
                Are you sure to delete the dashboard &apos;{dashboard.name}&apos;?
              </Typography>
              <Button
                sx={{
                  width: 'fit-content',
                  alignSelf: 'flex-end',
                }}
                type="submit"
                color="secondary"
                variant="contained"
              >
                Delete
              </Button>
            </Box>
          </form>
        </Card>
      </Modal>
    </>
  );
};

export default AdminAddDashboardConfirmDeleteModal;
